import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionForm_Actor_Create_Mutation = graphql(`
  mutation MissionForm_Actor_Create(
    $actor: ActorUnionInput!
    $actorableId: Id!
    $list: ActorListEnum!
    $versionData: VersionDataInput
  ) {
    createMissionActor(
      actor: $actor
      actorableId: $actorableId
      list: $list
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useCreateMissionActorMutation = () =>
  useGraphQLMutation(MissionForm_Actor_Create_Mutation);
